export default "__VITE_ASSET__B14nPiC2__"